import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "user-footer__wrapper" }
const _hoisted_4 = { class: "user-footer__list" }
const _hoisted_5 = { class: "user-footer__list-item" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("li", { class: "user-footer__list-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://rtl.hu/adatvedelmi-szabalyzat",
    class: "user-footer__link"
  }, "Adatkezelési tájékoztató")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", { class: "user-footer__list-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://rtl.hu/felhasznalasi-feltetelek",
    class: "user-footer__link"
  }, "ÁSZF")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, _toDisplayString(new Date().getFullYear()) + " © RTL Magyarország. Minden jog fenntartva.", 1),
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", _hoisted_5, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.openCookieBox()), ["prevent"])),
              href: "",
              class: "user-footer__link"
            }, "Sütik beállítása")
          ]),
          _hoisted_6,
          _hoisted_7
        ])
      ])
    ])
  ]))
}